
import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route, Routes,
  Link
} from 'react-router-dom';



import logo from '../logo_b.png'
import logob from '../logob.png'
import logo_black from '../logo_black.png'

import PlTitle from './PlTitle';
import Config from '../Config';
import FormatDecimal from '../helpers/FormatDecimal';


import ma_access from '../ma_access.png'
import ma_ankiety from '../ma_ankiety.png'
import ma_calc from '../ma_calc.png'
import ma_emp from '../ma_emp.png'
import ma_kids from '../ma_kids.png'
import ma_msg from '../ma_msg.png'
import ma_raporty from '../ma_raporty.png'
import ma_settings from '../ma_settings.png'
import ma_news from '../ma_news.png'


import mz_access from '../mz_access.png'
import mz_ankiety from '../mz_ankiety.png'
import mz_calc from '../mz_calc.png'
import mz_emp from '../mz_emp.png'
import mz_kids from '../mz_kids.png'
import mz_msg from '../mz_msg.png'
import mz_raporty from '../mz_raporty.png'
import mz_settings from '../mz_settings.png'
import mz_news from '../mz_news.png'

import mc_access from '../mc_access.png'
import mc_ankiety from '../mc_ankiety.png'
import mc_calc from '../mc_calc.png'
import mc_emp from '../mc_emp.png'
import mc_kids from '../mc_kids.png'
import mc_msg from '../mc_msg.png'
import mc_raporty from '../mc_raports.png'
import mc_settings from '../mc_settings.png'
import mc_news from '../mc_news.png'

import callx from '../callx.png'
import cally from '../cally.png'



function ParentMenuLeft(props)
{
 
        const [menuSelected, setMenuSelected] = useState(props.mainView.menuSelected);
        const [viewSelected, setViewSelected] = useState(props.mainView.viewSelected);
        const [idSelected, setIdSelected] = useState(props.mainView.idSelected);

        const [mVisible, setMVisible] = useState(props.mainView.menuVisible);

        const [css, setCss] = useState([]);


        const showFullMenu = () => {
            props.mainView.changeMenuStatus(1);
        }

        
        if(mVisible != props.mainView.menuVisible )
        {
            setMVisible(props.mainView.menuVisible);
        }


        if(props.mainView.menuSelected != menuSelected || props.mainView.viewSelected != viewSelected || props.mainView.idSelected != idSelected)
        {
                setMenuSelected(props.mainView.menuSelected);
                setViewSelected(props.mainView.viewSelected);
                setIdSelected(props.mainView.idSelected);

                var c = new Array();
                setCss({
                    [props.mainView.menuSelected+"_"+props.mainView.viewSelected]: "selected_m",
                    [props.mainView.menuSelected]: "selected_h",
                });
        }


        if(mVisible == 0)
        {
            return null;
        }


        if(mVisible == 2) //zwinięte menu dla aplikacji mobilnej..
        {            
                return  <div className='menu_left menu_left_short' onClick={showFullMenu}>
                            <div className='btn_show_menu'> - wysuń menu główne - </div>
                       </div>
        }


        const setStyleGreen = () => { props.mainView.setStyle(1); }
        const setStyleWhite = () => { props.mainView.setStyle(2); }

       
       // var new_kid_req = props.mainView.getGlobal('new_kid_req');
     //   var new_msg = props.mainView.getGlobal('new_msg');

     //  var kids = props.mainView.getGlobal('kids');


        return (
            <div className='menu_left '>
                

                <div className={'logo_view ' +  css['home']   } >
                   <img src={logob} className='logo_elizak link_normal logo_white' module="home" view="start" id="" onClick={props.mainView.quickGo} />                                
                   <img src={logo_black} className='logo_elizak link_normal logo_green' module="home" view="start" id="" onClick={props.mainView.quickGo} />                                

                   <div>
                     <PlTitle userData={props.userData} />
                    </div>

                </div>          

                <ul className='' >
                   

                    <li  className={ css['news']  }   module="news" view="wall" id="" onClick={props.mainView.quickGo} >
                        
                        <span className="link_normal link_head"   module="news" view="wall" id=""  mtop="1" onClick={props.mainView.quickGo} >
                            <img  className='img_ma' src={ma_news}/>
                            <img  className='img_mc' src={mc_news}/>
                            <img  className='img_mz' src={mz_news}/>
                            {props.userData.dic.menu_news}
                        </span>
                      
                        <div className={'mtitle link_normal' + ' ' + css["news_wall"] } module="news" view="wall" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mPosts}</div> 
                        <div className={'mtitle link_normal' + ' ' + css["news_eat"] }  module="news" view="eat" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mEat}</div>  
                        <div className={'mtitle link_normal' + ' ' + css["news_day"] }  module="news" view="day" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mDayP}</div>  
                        <div className={'mtitle link_normal' + ' ' + css["news_calendar"] }  module="news" view="calendar" id="" onClick={props.mainView.quickGo}  >{props.userData.dic.mCalendar}</div>  
                    </li>



                    <li  className={ css['mykid']  }   module="mykid" view="free" id="" onClick={props.mainView.quickGo} >
                        
                        <span className="link_normal link_head"   module="mykid" view="free" id=""  mtop="1" onClick={props.mainView.quickGo} >
                            <img  className='img_ma' src={ma_kids}/>
                            <img  className='img_mc' src={mc_kids}/>
                            <img  className='img_mz' src={mz_kids}/>
                            {props.userData.dic.menu_mykid}
                        </span>
                      

                        <div className={'mtitle link_normal' + ' ' + css["mykid_free"] } module="mykid" view="free" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mFree}</div> 
                        <div className={'mtitle link_normal' + ' ' + css["mykid_layette"] } module="mykid" view="layette" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mThing}</div> 
                        <div className={'mtitle link_normal' + ' ' + css["mykid_book"] } module="mykid" view="book" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mBook}</div> 
                        <div className={'mtitle link_normal' + ' ' + css["mykid_hours"] } module="mykid" view="hours" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mHour}</div> 
                        <div className={'mtitle link_normal' + ' ' + css["mykid_pickup"] } module="mykid" view="pickup" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mx_pickup}</div> 
                            
                    </li>


                    <li  className={ css['pay']  }   module="pay" view="invoice" id="" onClick={props.mainView.quickGo} >

                        <span className="link_normal link_head"   module="pay" view="invoice" id=""  mtop="1" onClick={props.mainView.quickGo} >
                            <img  className='img_ma' src={ma_calc}/>
                            <img  className='img_mc' src={mc_calc}/>
                            <img  className='img_mz' src={mz_calc}/>
                            {props.userData.dic.menu_calc}
                        </span>

                        <div className={'mtitle link_normal' + ' ' + css["pay_invoice"] } module="pay" view="invoice" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mInvoices}</div> 
                      

                    </li>




                    <li  className={ css['msg']  }   module="msg" view="received" id="" onClick={props.mainView.quickGo} >

                    <span className="link_normal link_head"   module="msg" view="received" id=""  mtop="1" onClick={props.mainView.quickGo} >
                        <img  className='img_ma' src={ma_msg}/>
                        <img  className='img_mc' src={mc_msg}/>
                        <img  className='img_mz' src={mz_msg}/>
                        {props.userData.dic.menu_msg}
                    </span>

                    <div className={'mtitle link_normal' + ' ' + css["msg_new"] } module="msg" view="new" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mNew}</div> 
                    <div className={'mtitle link_normal' + ' ' + css["msg_sended"] } module="msg" view="sended" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mSended}</div> 
                    <div className={'mtitle link_normal' + ' ' + css["msg_received"] } module="msg" view="received" id="" onClick={props.mainView.quickGo}>{props.userData.dic.mReceived}</div> 
                   


                    </li>


                  

                </ul>

                <div className='version_x'>
             
                     
                <span className='settings_ico'     >
                        <img  className='img_white' src={ma_settings}  module="home" view="account" id="" onClick={props.mainView.quickGo}/>
                        <img  className='img_black' src={mc_settings}  module="home" view="account" id="" onClick={props.mainView.quickGo} />                        
                    </span>   

                    &nbsp;
              
 
                    &nbsp;

                    <span className='settings_ico'     >
                        <img  className='img_white' src={cally}  module="home" view="support" id="" onClick={props.mainView.quickGo}/>
                        <img  className='img_black' src={callx}  module="home" view="support" id="" onClick={props.mainView.quickGo} />                        
                    </span> 

                    &nbsp;    
                   
                    &nbsp;
                    <span className='style_circle' onClick={setStyleWhite} title='Zmień style panelu'>&nbsp;</span>
                    &nbsp;&nbsp;
                    <span className='style_circle_g' onClick={setStyleGreen} title='Zmień style panelu'>&nbsp;</span>
                    &nbsp; &nbsp;                     
                    <sup>Wersja: <FormatDecimal value={Config.app_version} /> </sup>
                </div> 
           


            </div>
        )
}


export default ParentMenuLeft;